import "../styles/general.css";
import "leaflet/dist/leaflet.css";

import L from "leaflet";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../components/header/Header";
import DesktopView from "../components/desktopview/DesktopView";
import { useNavigate } from "react-router-dom";
import { MapContainer, Marker, TileLayer, useMapEvent } from "react-leaflet";
import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from "axios";
import SetServicePlaceTime from "../components/setserviceplacetime/SetServicePlaceTime";
import MessageModals from "../components/modals/MessageModals";
import ServicePlaceDescModal from "../components/modals/ServicePlaceDescModal";
import BlueLoader from "../components/loader/BlueLoader";

import { MdDateRange } from "react-icons/md";
import { useCookies } from "react-cookie";
import { BiCurrentLocation } from "react-icons/bi";
import useGeoLocation from "../hooks/useGeoLocation";
import globalContext from "../Contexts/GlobalContext";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import useRequestHeader from "../hooks/useRequestHeader";

export default function SetServicePlaceDetails() {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const contextData = useContext(globalContext);
  /// root api address section end ///
  const [cookies, setCookies, removeCookies] = useCookies();
  const requestHeader = useRequestHeader();

  const navigate = useNavigate();
  const [addressStatus, setAddressStatus] = useState("");
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [address, setAddress] = useState("");
  const [hasGeoErr, setHasGeoErr] = useState(false);

  const icon = L.icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    iconUrl: "../assets/images/pin/pin (4).png",
    shadowUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png",
  });
  const [mapIsSelected, setMapIsSelected] = useState(false);
  const [markerPosition, setMarkerPosition] = useState([35.699739, 51.338097]);
  const [isLoading, setIsLoading] = useState(false);
  const [map, setMap] = useState();
  function MyComponent() {
    const map = useMapEvent("click", (e) => {
      setMapIsSelected(true);
      setMarkerPosition([e.latlng.lat, e.latlng.lng]);
      setLat(e.latlng.lat);
      setLng(e.latlng.lng);
      map.setView(e.latlng, 15);
      if (e.latlng.lat && e.latlng.lng) {
        setIsLoading(true);
        const config = {
          headers: requestHeader,
        };
        axios
          .post(
            `${BASE_URL}/getAddress`,
            {
              lat: e.latlng.lat,
              lng: e.latlng.lng,
            },
            config
          )
          .then((res) => {
            setAddress(res?.data?.Data?.formatted_address);
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
    });
    setMap(map);

    return null;
  }

  const [isServicePlaceTimeOpen, setIsServicePlaceTimeOpen] = useState("");

  const monthName = [
    "",
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];
  const [day, setDay] = useState("");
  const [time, setTime] = useState("");
  const sendReq = () => {
    let isOkToSend = true;

    if (!lat || !lng || address.length <= 10) {
      isOkToSend = false;
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("تعیین آدرس و موقعیت مکانی الزامیست");
    }

    if (!day || !time) {
      isOkToSend = false;
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("انتخاب زمان سرویس الزامیست");
    }
    if (isOkToSend) {
      setIsDescModalOpen(true);
    }
  };
  const [isDescModalOpen, setIsDescModalOpen] = useState(false);
  const [turnTime, setTurnTime] = useState([]);
  const [referenceTimeId, setreferenceTimeId] = useState();
  useEffect(() => {
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/service/place/turnTime`,
        {
          type: cookies?.servicePlaceType,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            setTurnTime(res?.data?.Data);
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
    if (!cookies?.plate) {
      navigate("/add-car");
    }
    if (!cookies?.servicePlaceType) {
      navigate("/servicePlace");
    }
  }, []);
  const location = useGeoLocation();
  const goMyLoc = () => {
    if (location?.error?.code === 1) {
      window.location.href = "app-settings:location";
      contextData.setIsToastOpen(true);
      contextData.setToastMessage(
        "لطفا اجازه دسترسی به موقعیت مکانی را فعال کنید"
      );
    }
    if (location.coordinates.lat && location.coordinates.lng) {
      setMapIsSelected(true);
      setMarkerPosition([location.coordinates.lat, location.coordinates.lng]);
      setLat(location.coordinates.lat);
      setLng(location.coordinates.lng);
      map.setView(location.coordinates, 15);
      if (location?.coordinates?.lat && location?.coordinates?.lng) {
        setIsLoading(true);
        const config = {
          headers: requestHeader,
        };
        axios
          .post(
            `${BASE_URL}/getAddress`,
            {
              lat: location.coordinates.lat,
              lng: location.coordinates.lng,
            },
            config
          )
          .then((res) => {
            setAddress(res?.data?.Data?.formatted_address);
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
    }
  };
  return (
    <>
      <div className="hidden min-[1024px]:block ">
        <DesktopView />
      </div>
      <div
        className="absolute w-full top-0 bottom-0 flex flex-col items-center justify-between  bg-[#153038] min-[1024px]:hidden "
        onClick={() => {
          if (isServicePlaceTimeOpen === "true") {
            setIsServicePlaceTimeOpen("false");
          }
        }}
      >
        <Header relt="relative" />
        <SetServicePlaceTime
          isServicePlaceTimeOpen={isServicePlaceTimeOpen}
          setIsServicePlaceTimeOpen={setIsServicePlaceTimeOpen}
          setDay={setDay}
          setTime={setTime}
          day={day}
          time={time}
          turnTime={turnTime}
          setreferenceTimeId={setreferenceTimeId}
        />
        {contextData?.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}
        {isDescModalOpen && (
          <ServicePlaceDescModal
            setIsDescModalOpen={setIsDescModalOpen}
            lat={lat}
            lng={lng}
            referenceTimeId={referenceTimeId}
            address={address}
          />
        )}

        <div
          className={`absolute bottom-0 mb-[8vw] top-[10vw] w-[85vw] h-auto flex flex-col items-start justify-start  gap-y-[2vw] overflow-auto`}
        >
          <div className="w-full flex flex-col items-center justify-center p-[2vw] mt-[12vw]">
            <p className="font-font_primary_A text-[5.5vw] text-white font-normal">
              سرویس خودرو در محل
            </p>
          </div>
          <div className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw] text-color-primary-C3">
            <span> آدرس و زمان انجام سرویس خودرو خود را تعیین نمایید</span>
          </div>

          <div className="w-full flex flex-col items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A  ">
            <div
              className="relative w-full min-h-[15vw] flex flex-col items-center justify-center border-[1px] rounded-[1.8vw] border-color-primary-C py-[1vw] px-[4vw]   "
              onClick={() => {
                setIsServicePlaceTimeOpen("true");
              }}
            >
              <div className="w-full flex items-center justify-between pl-[8vw] ">
                <div className=" flex items-center justify-between gap-x-[2vw] ">
                  <div className="h-full flex items-center justify-center   ">
                    <div
                      className={`w-[4.5vw] h-[4.5vw] rounded-full border-[1px] border-color-primary-C flex items-center justify-center `}
                    >
                      {day && time && (
                        <div className="w-[2.25vw] h-[2.25vw] bg-color-primary-B rounded-full"></div>
                      )}
                    </div>
                  </div>
                  <div className="h-full  flex flex-col items-center justify-between gap-y-[1vw]  ">
                    <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw] text-color-primary-C3   ">
                      زمان سرویس
                    </span>
                  </div>
                </div>
                <div
                  dir="ltr"
                  className=" flex items-center justify-between gap-x-[2vw] text-white font-font_primary_A  py-[0.5vw] text-[3.5vw]  rounded-[0.9vw] pt-[2.5vw]"
                >
                  {" "}
                  <span dir="rtl">
                    {day.split("/")[1] ? day.split("/")[1] : ""}
                    {` ${monthName[day.split("/")[0] ? day.split("/")[0] : 0]}`}
                  </span>
                  <span>{time}</span>
                </div>
              </div>
              <span className="absolute left-[4vw] top-1/2 -translate-y-[45%] text-white">
                <MdDateRange size={20} />
              </span>
            </div>
          </div>
          {/* /// new address section chose opt start /// */}
          <div className="w-full flex flex-col items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A  ">
            <div
              className="relative w-full min-h-[15vw] flex flex-col items-center justify-center border-[1px] rounded-[1.8vw] border-color-primary-C py-[1vw] px-[4vw] "
              onClick={() => {
                setAddressStatus("new");
              }}
            >
              <div className="w-full flex items-center justify-between mt-[3vw]">
                <div className=" flex items-center justify-between gap-x-[2vw]">
                  <div className="h-full flex items-center justify-center">
                    <div
                      className={`w-[4.5vw] h-[4.5vw] rounded-full border-[1px] border-color-primary-C flex items-center justify-center `}
                      onClick={(e) => {}}
                    >
                      {lat && lng && address?.length > 10 && (
                        <div className="w-[2.25vw] h-[2.25vw] bg-color-primary-B rounded-full"></div>
                      )}
                    </div>
                  </div>
                  <div className="h-full  flex flex-col items-center justify-between gap-y-[1vw]  ">
                    <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw] text-color-primary-C3 ">
                      محل سرویس
                    </span>
                  </div>
                </div>
              </div>
              <div className="w-full   ">
                <div className="w-full flex items-center justify-center mt-[3vw]">
                  <div
                    className={`w-full h-full rounded-[4vw] relative ${
                      hasGeoErr && !mapIsSelected
                        ? "border-[4px] border-[#ff8888]"
                        : "border-[4px] border-transparent"
                    }`}
                  >
                    <MapContainer
                      center={[
                        `${lat ? lat : 35.699739}`,
                        `${lng ? lng : 51.338097}`,
                      ]}
                      zoom={14}
                      zoomControl={false}
                      scrollWheelZoom={true}
                      attributionControl={false}
                      style={{
                        width: "100%",
                        height: "70vw",
                      }}
                      className="rounded-[1.89vw]"
                    >
                      <MyComponent setMarkerPosition={setMarkerPosition} />

                      <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />

                      {mapIsSelected && (
                        <Marker
                          position={markerPosition}
                          draggable
                          icon={icon}
                        ></Marker>
                      )}
                    </MapContainer>
                    <div
                      className="absolute  bg-color-primary-C2 bottom-[2vw] right-[2vw] text-color-primary-B text-[8vw] rounded-[2vw] z-[400]"
                      onClick={goMyLoc}
                    >
                      <BiCurrentLocation />
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative w-full flex flex-col items-center justify-center mt-[2vw]  px-[2vw]  gap-y-[1vw] mb-[3vw]">
                {isLoading && (
                  <div className="absolute w-full h-full flex items-center justify-center  backdrop-blur-[2px] z-50">
                    <BlueLoader position="" width={13} />
                  </div>
                )}
                <div className="w-full relative flex items-center justify-between ">
                  <label
                    htmlFor="address"
                    className="font-font_primary_A  text-color-primary-C3 font-extralight text-[4vw]  "
                  >
                    آدرس:
                  </label>
                  <span
                    className={`absolute left-[1vw] top-[2vw] font-font_primary_A text-[3vw] ${
                      address?.length === 150
                        ? "text-[#ff0000]"
                        : "text-color-primary-C"
                    }  h-full`}
                  >
                    {address?.length}/150
                  </span>
                </div>
                <textarea
                  autoComplete={"off"}
                  dir="rtl"
                  id="address"
                  value={address}
                  maxLength={150}
                  className={`w-[99%] h-[12vw] outline-none bg-transparent  line-DashSpace-white  text-[3.5vw] focus:text-[3.5vw] py-[1vw] px-[1vw]  text-color-primary-A`}
                  onChange={(e) => {
                    setAddress(e.target.value);
                  }}
                ></textarea>
              </div>
            </div>
          </div>
          {/* /// new address section chose opt end /// */}
          <div className="w-full flex flex-col items-center justify-center mt-[7.5vw]">
            <button
              className="w-[85vw] h-[12vw] flex items-center justify-center bg-color-primary-B text-[5vw] text-[#103038] font-font_primary_A rounded-[1.8vw] "
              onClick={sendReq}
            >
              ارسال درخواست
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
